/** Interrupt names/descriptions from the API are often snake_case; show spaces in the UI. */
export function formatInterruptText(text: string | null | undefined): string {
  if (text == null || text === '') return '';
  return text.replace(/_/g, ' ');
}

/** Convert a snake_case interrupt name (e.g. "fan_asks_for_content") to the
 *  camelCase i18n key used in chatAssistant:interrupts (e.g. "fanAsksForContent"). */
export function interruptNameToKey(name: string): string {
  return name.toLowerCase().replace(/_([a-z])/g, (_, c: string) => c.toUpperCase());
}
